/// <amd-module name="SuiteCommerce.Blog.PostList.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostList.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Post.Collection"], function (require, exports, Backbone_1, Post_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostListModel = void 0;
    var PostListModel = /** @class */ (function (_super) {
        __extends(PostListModel, _super);
        function PostListModel(options) {
            var _this = _super.call(this, options) || this;
            _this.showPostCardsPlaceholders = options.showPostCardsPlaceholders;
            _this.posts = options.posts;
            _this.postCardLayout = options.postCardLayout;
            _this.postCardPlaceholdersQuantity;
            if (options.title)
                _this.title = options.title;
            return _this;
        }
        Object.defineProperty(PostListModel.prototype, "posts", {
            get: function () {
                if (!this.get('posts'))
                    this.posts = new Post_Collection_1.PostCollection();
                return this.get('posts');
            },
            set: function (posts) {
                this.set('posts', posts);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "title", {
            get: function () {
                return this.get('title');
            },
            set: function (title) {
                this.set('title', title);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "showPostCardsPlaceholders", {
            get: function () {
                return this.get('showPostCardsPlaceholders');
            },
            set: function (showPostCardsPlaceholders) {
                this.set('showPostCardsPlaceholders', showPostCardsPlaceholders);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "postCardPlaceholdersQuantity", {
            get: function () {
                return this.get('postCardPlaceholdersQuantity');
            },
            set: function (postCardPlaceholdersQuantity) {
                this.set('postCardPlaceholdersQuantity', postCardPlaceholdersQuantity);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "postCardLayout", {
            get: function () {
                return this.get('postCardLayout');
            },
            set: function (postCardLayout) {
                this.set('postCardLayout', postCardLayout);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "highlightInCards", {
            get: function () {
                return this.get('highlightInCards');
            },
            set: function (highlightInCards) {
                this.set('highlightInCards', highlightInCards);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PostListModel.prototype, "hideList", {
            get: function () {
                return this.get('hideList');
            },
            set: function (hideList) {
                this.set('hideList', hideList);
            },
            enumerable: false,
            configurable: true
        });
        PostListModel.prototype.getContainsDummyModel = function () {
            return this.posts.filter(function (model) {
                return model.isDummy;
            }).length > 0;
        };
        return PostListModel;
    }(Backbone_1.Model));
    exports.PostListModel = PostListModel;
});
